import { Record, List } from 'immutable';

const defaultValues = {
  filterValue: '',
};

export default class SearchFilterItemValue extends Record(defaultValues, SearchFilterItemValue) {
  constructor(values) {
    super({
      ...values,
    });
  }
}

export const SearchFilterItemValues = (data) => {
  let filterItemValues = new List();
  if (data) {
    data.forEach((value) => {
      filterItemValues = filterItemValues.push(new SearchFilterItemValue(value));
    });
  }
  return filterItemValues;
};
